import { Component, inject, OnInit, signal } from '@angular/core';
import { HeaderComponent } from '../../../layout/header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { NzResultComponent } from 'ng-zorro-antd/result';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NgIf } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { FormsModule } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';
import { MeetingServiceService } from '../../services/meeting-service/meeting-service.service';
import { ar_EG, en_US, NzI18nService } from 'ng-zorro-antd/i18n';
import { ApecoToastrService } from '../../services/apeco-toastr.service';
import moment from 'moment/moment';

@Component({
  selector: 'app-school-manager-meeting',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NzResultComponent,
    NzButtonComponent,
    NzSpinComponent,
    SvgIconComponent,
    NzIconDirective,
    NgIf,
    TranslateModule,
    NzDatePickerComponent,
    FormsModule
  ],
  templateUrl: './school-manager-meeting.component.html',
  styleUrl: './school-manager-meeting.component.scss'
})
export class SchoolManagerMeetingComponent implements OnInit {
  private i18n = inject(NzI18nService);
  loading = false;
  code = '';
  suggestedDate: any;
  today = new Date();
  submitted = signal(false);
  token = signal('');
  optionId = signal<any>(null);
  message = this.translateService.instant('meeting-message');
  successFlag = false;
  errorMsg!: string;

  disabledDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) < 0;

  constructor(
    private meetingService: MeetingServiceService,
    private activatedRoute: ActivatedRoute,
    private toastr: ApecoToastrService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.handelRoute();
    this.handelLanguageChange();
  }

  private handelRoute() {
    this.activatedRoute.queryParams
      .pipe(
        switchMap((params: Params) => {
          this.loading = true;
          this.optionId.set(Number(params['optionId']));
          this.token.set(params['token']);
          const body = { optionId: Number(params['optionId']) };
          this.code = params['Code'];
          return this.meetingService.performAction(body, this.token());
        })
      )
      .subscribe(
        () => {
          this.loading = false;
        },
        (error) => {
          console.log(error);

          if (error.status == 401) {
            this.errorMsg =
              localStorage.getItem('lang') == 'ar'
                ? 'تم انتهاء صلاحيه الرابط'
                : 'Link Has Been Expired.';
          } else {
            this.errorMsg = error?.error?.Message;
          }

          this.loading = false;
          this.code = 'Error';
        }
      );
  }

  performAction() {
    this.submitted.set(true);

    if (this.suggestedDate) {
      this.loading = true;
      const date = moment(this.suggestedDate).format('YYYY-MM-DD h:mm a');

      this.meetingService
        .performAction(
          {
            optionId: Number(this.optionId()),
            comments: `${date} الوقت المقترح`
          },
          this.token()
        )
        .subscribe(
          () => {
            this.loading = false;

            this.toastr.success(
              this.translateService.instant('meeting-message')
            );

            this.successFlag = true;
          },
          (error) => {
            console.log(error);
            this.loading = false;

            if (error.status == 401) {
              this.toastr.error(error?.message);
            } else {
              this.toastr.error(error?.error?.Message);
            }
          }
        );
    }
  }

  private handelLanguageChange() {
    this.translateService.onLangChange.subscribe((lang) => {
      this.i18n.setLocale(lang?.lang === 'en' ? en_US : ar_EG);
    });
  }
}
